import React from "react";

export const StoryLocationLabel = ({ story, preferState = false, testId, className = "" }) => {
  const location = story.location;
  const state = preferState ? location?.state : null;
  const country = location?.country_name || (story.origin_country || "").replace(/-/g, " ");
  if (!country && !state) return null;
  const detail = state ? `${state.name} · ${country} · ISO 3166-2 ${state.code}${location.basis === "mentioned_in_reporting" ? " · Mentioned in reporting" : ""}` : country;
  return <span className={`dnh-location-label ${className}`} data-testid={testId} data-location-kind={state ? "state" : "country"} data-iso-code={state?.code || location?.country_code || ""} title={detail}>{state?.name || country}</span>;
};